import { getLocale } from "../runtime";

const sv_couponcode = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Rabattkod?`
};

const couponcode = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_couponcode(inputs)
	return "couponCode";
};

export { couponcode as "couponCode" };